<style lang="scss"  scoped>

</style>

<template>
    <div class="navbar_icon-link navbar_language-selector" data-cover="#lang-selector-cover">
        <div class="ml-2 mr-n1 d-flex">
            <span class="text-theme-color">
                <span class="pr-1 no-pointers">{{lang.toUpperCase()}}</span>
                <!-- HIDDEN ENGLISH <img width="9" class="ml-1 mr-n1 navbar_lang-arrow" alt="icona" :src="'/images/becco-giu-' + theme + '.svg'"/> -->
            </span>
            <!--<span class="d-flex pl-2 navbar_other-languages">
                <a :href="itUrl" v-if="lang != 'it'" class="pl-2 pr-1 text-theme-color" :class="{'text-white' : separated_colors && !menu_open && theme == 'light'}">IT</a>
                <a :href="enUrl" v-if="lang != 'en'"  class="pl-2 pr-1 text-theme-color" :class="{'text-white' : separated_colors && !menu_open && theme == 'light'}">EN</a>
                <!- -<a :href="deUrl" v-if="lang != 'de'"  class="pl-2 pr-1 text-theme-color" :class="{'text-white' : separated_colors && !menu_open && theme == 'light'}">DE</a>- ->
            </span>-->
        </div>
    </div>
</template>
<script>

export default {
    props: ['lang', 'itUrl', 'deUrl', 'enUrl'],
    data: function () {
        return {
            separated_colors: false,
            menu_open: false,
        };
    },
    mounted() {
    },
    methods: {
    },
    beforeDestroy() {
    },
}
</script>
